export default [
  {
    path: '/cases',
    name: 'cases',
    component: () => import('@/views/cases/Cases.vue'),
    meta: {
      pageTitle: 'DEBTIA_CASES',
      breadcrumb: [
        {
          text: 'DEBTIA_CASES',
          active: true,
        },
      ],
      action: 'read',
      resource: 'Auth',
    },
  },
  {
    path: '/cases/details/:id',
    name: 'case-details',
    component: () => import('@/views/cases/CaseDetails.vue'),
    meta: {
      pageTitle: 'DEBTIA_CASE_DETAILS',
      breadcrumb: [
        {
          text: 'DEBTIA_CASES',
          to: { name: 'cases' },
        },
        {
          text: 'DEBTIA_CASE_DETAILS',
          active: true,
        },
      ],
      action: 'read',
      resource: 'Auth',
    },
  },
  // ============================================================
  // NY SAGOPRETTELSE - Selvstændig side med forbedret UX
  // Erstatter den gamle modal-baserede wizard med en moderne,
  // fuld-side oplevelse inkl. OCR og CVR-opslag
  // ============================================================
  {
    path: '/cases/create',
    name: 'case-create',
    component: () => import('@/views/cases/create/CreateCase.vue'),
    meta: {
      pageTitle: 'DEBTIA_ADD_CASE',
      breadcrumb: [
        {
          text: 'DEBTIA_CASES',
          to: { name: 'cases' },
        },
        {
          text: 'DEBTIA_ADD_CASE',
          active: true,
        },
      ],
      action: 'read',
      resource: 'Auth',
    },
  },
]
